export default __webpack_public_path__ + "static/media/shurik.adcd044f.png";